const highlightSidebarLinks = (containerSelector) => {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  const currentPath = window.location.pathname;
  const buttons = container.querySelectorAll('.text-7-button');

  buttons.forEach(button => {
    const link = button.querySelector('a');
    if (!link) return;

    try {
      const linkPath = new URL(link.href).pathname;

      if (currentPath === linkPath) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    } catch (e) {}
  });
};

const activateHeaderTabByUrl = () => {
  const currentPath = window.location.pathname;
  
  const tabsWrap = document.querySelector('.kt-tabs-wrap');
  if (!tabsWrap) return;

  const performClickAndClean = () => {
    
    const tabLinks = tabsWrap.querySelectorAll('.kt-tabs-content-wrap a');
    let matchedTabLink = null;

    for (const link of tabLinks) {
      try {
        const href = link.getAttribute('href');
        if (!href) continue;
        
        const linkPath = new URL(href, window.location.origin).pathname;

        if (currentPath === linkPath || currentPath === linkPath + '/' || currentPath + '/' === linkPath) {
          matchedTabLink = link;
          break;
        }
      } catch (e) {}
    }

    if (!matchedTabLink) return;

    tabsWrap.querySelectorAll('.current-menu-item, .current_page_item').forEach(el => {
      el.classList.remove('current-menu-item', 'current_page_item');
    });

    const listItem = matchedTabLink.closest('li.wp-block-kadence-navigation-link');
    if (listItem) {
      listItem.classList.add('current-menu-item', 'current_page_item');
    }

    const tabContent = matchedTabLink.closest('.wp-block-kadence-tab');
    if (!tabContent) return;

    const tabId = tabContent.getAttribute('aria-labelledby');
    if (!tabId) return;

    const tabHeaderLi = tabsWrap.querySelector(`.kt-tabs-title-list #${tabId}`);
    
    if (tabHeaderLi) {
      
      tabsWrap.querySelectorAll('.kt-tabs-title-list .kt-title-item').forEach(li => {
        li.classList.remove('kt-tab-title-active');
        li.classList.add('kt-tab-title-inactive');
        
        const linkInside = li.querySelector('a');
        if (linkInside) {
          linkInside.setAttribute('aria-selected', 'false');
          linkInside.setAttribute('tabindex', '-1');
        }
      });

      tabHeaderLi.classList.remove('kt-tab-title-inactive');
      tabHeaderLi.classList.add('kt-tab-title-active');
      
      const activeLinkInside = tabHeaderLi.querySelector('a');
      if (activeLinkInside) {
        activeLinkInside.setAttribute('aria-selected', 'true');
        activeLinkInside.setAttribute('tabindex', '0');
        
        activeLinkInside.click();
      }
    }
  };

  setTimeout(() => {
    performClickAndClean();
  }, 250); 
};

export const activeMenu = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const body = document.body;
    const bodyClasses = Array.from(body.classList);

    const htmlLang = document.documentElement.lang.toLowerCase();
    const isEnglish = htmlLang.startsWith('en');

    const menuMapping = {
      'parent-pageid-3395': 'sektory rynku',
      'parent-pageid-6965': 'industries',
      'parent-pageid-3481': 'rozwiązania',
      'parent-pageid-7105': 'solutions',
      'single-post': 'Insights',
      'page-id-1877': 'Insights',
      'page-id-2358': 'Insights',
      'page-id-4604': 'Insights',
      'single-wydarzenia': 'Insights',

      'single-usluga': isEnglish ? 'services' : 'usługi',
      'single-case-study': isEnglish ? 'Success Stories' : 'Historie sukcesu',
      'single-oferta-pracy': isEnglish ? 'about us' : 'o nas',
    };
    
    // --- KLIKNIĘCIE W TAB W HEADERZE (ODPALA SIĘ OD RAZU NA PODSTRONACH USŁUG) ---
    if (bodyClasses.includes('single-usluga')) {
      activateHeaderTabByUrl();
    }

    // Handle about page links
    if (bodyClasses.includes('page-id-7105') || bodyClasses.includes('page-id-1117') || bodyClasses.includes('page-id-63') || bodyClasses.includes('page-id-878') || bodyClasses.includes('page-id-4702') || bodyClasses.includes('page-id-4646') || bodyClasses.includes('page-id-4652') || bodyClasses.includes('page-id-5198') ) {
      highlightSidebarLinks('.about-links');
    }

    if (bodyClasses.includes('parent-pageid-7105') || bodyClasses.includes('parent-pageid-3481')) {
      highlightSidebarLinks('.solutions-links');
    }

    if (bodyClasses.includes('parent-pageid-3395') || bodyClasses.includes('parent-pageid-6965')) {
      highlightSidebarLinks('.sectors-links');
    }

    if (bodyClasses.includes('single-post') || bodyClasses.includes('page-id-1877')|| bodyClasses.includes('page-id-4604')) {
      const blogLinks = document.querySelector('.blogs-links');
      if (blogLinks) {
        const text7Buttons = blogLinks.querySelectorAll('.text-7-button');
        text7Buttons.forEach(button => {
          button.classList.remove('active');
        });
        const activeButton = blogLinks.querySelector('#blogs-links-1');
        if (activeButton) {
          activeButton.classList.add('active');
        }
      }
    }

    if (bodyClasses.includes('page-id-2358') || bodyClasses.includes('page-id-4724') || bodyClasses.includes('single-wydarzenia')) {
      const blogLinks = document.querySelector('.blogs-links');
      if (blogLinks) {
        const text7Buttons = blogLinks.querySelectorAll('.text-7-button');
        text7Buttons.forEach(button => {
          button.classList.remove('active');
        });
        const activeButton = blogLinks.querySelector('#blogs-links-2');
        if (activeButton) {
          activeButton.classList.add('active');
        }
      }
    }

    // Szukanie i podświetlanie głównego elementu w Menu (Services / Usługi)
    const activeClass = bodyClasses.find(className => menuMapping[className]);

    if (activeClass) {
      const phraseToFind = menuMapping[activeClass].toLowerCase();
      
      const navContainer = document.querySelector('.header-navigation, #masthead') || document;
      const navLinks = navContainer.querySelectorAll('.kb-nav-link-content');

      navLinks.forEach(link => {
        const text = link.textContent.toLowerCase().trim();

        if (text.includes(phraseToFind)) {
          const listItem = link.closest('li.wp-block-kadence-navigation-link');
          if (listItem) {
            listItem.classList.add('current-menu-item', 'current_page_item');
          }
        }
      });
    }
  });
};